import React, { useEffect, useState } from 'react';
import { getAllTrailsList, getTrailGeoJson } from '../../store/adminActions';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

function GeoFileDownload(props) {
    const { initAllTrailsList, trailsList, initCollection } = props;
    const [selectedTrailUUID, setSelectedTrailUUID] = useState(undefined);
    // trals list load
    useEffect(() => {
        if (!trailsList.length) {
            initAllTrailsList();
        }
    }, [trailsList, initAllTrailsList]);
    const onSelectTrail = (e) => {
        setSelectedTrailUUID(e.target.value);
    };
    const onDownloadInitiated = () => {
        initCollection(selectedTrailUUID);
    };
    if (!trailsList || !trailsList.length) {
        return <FormattedMessage id="admin.loadingTrails" />;
    }
    return (
        <>
            <select onChange={onSelectTrail} value={selectedTrailUUID}>
                {trailsList.map((trail, idx) => {
                    const { trailUUID, name } = trail;
                    return (
                        <option key={idx} value={trailUUID}>
                            {`${trailUUID} - ${name}`}
                        </option>
                    );
                })}
            </select>
            <button
                onClick={onDownloadInitiated}
                className={classNames({ inactive: !selectedTrailUUID })}
            >
                <span>Open existing</span>
            </button>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        trailsList: state.adminState.trailsList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initCollection: (uuid) => dispatch(getTrailGeoJson(uuid)),
        initAllTrailsList: () => dispatch(getAllTrailsList()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeoFileDownload);
